import type { CreateProjectComment201Auth } from './createProjectComment201Auth';
import type { CreateProjectComment201Author } from './createProjectComment201Author';

/**
 * 프로젝트 댓글 응답 데이터
 */
export type CreateProjectComment201 = {
  /** 인증 컨텍스트 정보 */
  auth?: CreateProjectComment201Auth;
  /** 기본 사용자 정보 */
  author: CreateProjectComment201Author;
  /** 직접적인 자식 댓글(답글) 수 */
  childCount?: number;
  /** 댓글 내용 */
  content: string;
  createdAt: string;
  /** 댓글 깊이 (0부터 시작) */
  depth?: number;
  /** 댓글 ID */
  id: string;
  likeCount?: number;
  liked?: boolean;
  /**
   * 부모 댓글 ID (답글일 경우 null)
   * @nullable
   */
  parentId?: string | null;
  updatedAt?: string;
};
